/* tslint:disable:max-classes-per-file */
import { Transform } from 'class-transformer';
import {
  IsDefined,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
} from 'class-validator';
import { EcomProductType } from '.';
import { LeadConfigurationType } from '../configuration';

export interface EcomCoupon {
  couponCashbackAmount: number;
  status: 'Active' | 'Redeemed';
  couponCode: string;
  campaignID: string;
  appliedItem?: EcomCouponAppliedItem;
  couponCashbackID?: string;
  appliedStage?: LeadConfigurationType;
}

export interface EcomCouponAppliedItem {
  productID: string;
  productOptionID: string;
  priceType: 'percentage' | 'fixed' | undefined;
  priceValue?: number;
  internalpriceType: 'percentage' | 'fixed' | undefined;
  internalpriceValue?: number;
  periodOfService?: number;
  periodUnit?: string;
  productType?: EcomProductType;
  sortOrder?: number;
  upgradeOption?: boolean;
}

export class EcomVoucher {
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Transform((p) => p?.toString(), { toClassOnly: true })
  cashVoucherID!: string;

  @IsDefined()
  @IsString()
  @IsNotEmpty()
  cashVoucherTitle!: string;

  @IsDefined()
  @IsString()
  @IsNotEmpty()
  campDiscountTitle!: string;
}

export class EcomCouponSettings {
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Transform((p) => p?.toString(), { toClassOnly: true })
  couponCashbackID!: string;

  @IsDefined()
  @IsString()
  @IsNotEmpty()
  couponCashbackTitle!: string;

  @IsDefined()
  @IsNumber()
  couponMaxDiscount!: number;

  @IsDefined()
  @IsNumber()
  couponMinDiscount!: number;

  @IsDefined()
  @IsNumber()
  noOfCouponOffered!: number;

  @IsOptional()
  @IsString()
  couponType!: string;

  @IsOptional()
  @IsString()
  entityType!: string;

  @IsOptional()
  @IsString()
  @Transform((p) => p?.toString(), { toClassOnly: true })
  entityTypeID!: string;

  @IsOptional()
  @IsString()
  oorjitCode!: string;

  @IsOptional()
  @IsString()
  entityKey!: string;
}
